
import { FileText, CreditCard } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import SEO from "@/components/SEO";
import useAnalytics from "@/hooks/use-analytics";
import { useEffect } from "react";

const AcessePortais = () => {
  const { trackPageView, trackPortalAccess } = useAnalytics();

  // Track page view
  useEffect(() => {
    trackPageView("acesse_portais", "utility_page");
  }, [trackPageView]);

  // Portal schema for SEO
  const portalSchema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Acesse nossos Portais | Dr.Cash",
    "description": "Acesse os portais de Boleto Parcelado e Antecipação de Cartão de Crédito da Dr.Cash para gerenciar suas operações financeiras.",
    "url": "https://drcash.com.br/acesse-portais",
    "mainEntity": {
      "@type": "ItemList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Portal Boleto Parcelado",
          "url": "https://portal.drcash.com.br/"
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "Portal Antecipação de Cartão de Crédito",
          "url": "https://drcashantecipacao.spike.cash/authentication/email/login"
        }
      ]
    }
  };

  // Handle portal access tracking
  const handlePortalAccess = (portalName: string) => {
    trackPortalAccess(portalName);
  };

  return (
    <div className="min-h-screen flex flex-col">
      <SEO
        title="Acesse nossos Portais | Dr.Cash - Área do Cliente e Ferramentas"
        description="Gerencie seus boletos parcelados e antecipe seus recebíveis de cartão de crédito acessando os portais da Dr.Cash. Ferramentas exclusivas para clientes."
        keywords="portal drcash, área do cliente dr.cash, gerenciamento boletos, antecipação cartão, login drcash"
        canonical="/acesse-portais"
        structuredData={portalSchema}
      />
      <Navbar />
      <main className="flex-grow py-24 px-4">
        <div className="container mx-auto max-w-4xl">
          <h1 className="text-3xl md:text-4xl font-bold text-drcash-maastricht-blue text-center mb-12">
            Acesse nossos Portais
          </h1>
          
          <div className="grid md:grid-cols-2 gap-6">
            {/* Portal Boleto Parcelado */}
            <Card className="transition-all duration-300 hover:shadow-lg hover:-translate-y-1">
              <CardContent className="p-6 flex flex-col items-center text-center h-full">
                <FileText className="h-12 w-12 text-drcash-caribbean-green mb-4" />
                <h2 className="text-xl font-bold text-drcash-maastricht-blue mb-3">
                  Portal Boleto Parcelado
                </h2>
                <p className="text-gray-600 mb-6">Simule pacientes, gerencie seus boletos parcelados, acompanhe pagamentos e tenha controle total das suas operações em um só lugar</p>
                <a 
                  href="https://portal.drcash.com.br/" 
                  className="btn-primary mt-auto w-full text-center"
                  onClick={() => handlePortalAccess("boleto_parcelado")}
                >
                  Acessar Portal
                </a>
              </CardContent>
            </Card>

            {/* Portal Antecipação */}
            <Card className="transition-all duration-300 hover:shadow-lg hover:-translate-y-1">
              <CardContent className="p-6 flex flex-col items-center text-center h-full">
                <CreditCard className="h-12 w-12 text-drcash-caribbean-green mb-4" />
                <h2 className="text-xl font-bold text-drcash-maastricht-blue mb-3">
                  Portal Antecipação de Cartão de Crédito
                </h2>
                <p className="text-gray-600 mb-6">Antecipe seus recebíveis de cartão de crédito com as melhores taxas do mercado e receba o valor em sua conta no mesmo dia</p>
                <a 
                  href="https://drcashantecipacao.spike.cash/authentication/email/login" 
                  className="btn-primary mt-auto w-full text-center"
                  onClick={() => handlePortalAccess("antecipacao_cartao")}
                >
                  Acessar Portal
                </a>
              </CardContent>
            </Card>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default AcessePortais;
